<template>
    <v-container class="d-flex justify-center align-center fill-height background-image">
        <v-col cols="12" md="8">
            <v-card class="pa-4" elevation="10">
                <v-card-title class="justify-center">
                    <h2>{{ $t('app.editarusuario') }}</h2>
                </v-card-title>

                <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <!-- Nombres y Apellidos -->
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="user.nombres" :label="$t('DatosU.nombre')"
                                    :rules="[rules.required]" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="user.apellidos" :label="$t('DatosU.apellidos')"
                                    :rules="[rules.required]" />
                            </v-col>
                        </v-row>

                        <!-- Correo y Contraseña -->
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="user.correo" :label="$t('DatosU.correo')"
                                    :rules="[rules.required, rules.email]" />
                            </v-col>

                            <!--                             <v-col cols="12" md="6">
                                <v-row align="center" no-gutters>
                                    <v-col cols="10">
                                        <v-text-field v-model="user.passuser" :type="showPassword ? 'text' : 'password'"
                                            label="Contraseña (opcional) - Dejar como aparece para mantener la actual"
                                            hint="Déjalo vacío para mantener la misma contraseña" counter dense />
                                    </v-col>

                                    <v-col cols="2" class="d-flex align-center">
                                        <v-checkbox v-model="showPassword" label="Show" hide-details dense />
                                    </v-col>
                                </v-row>
                            </v-col> -->
                        </v-row>

                        <!-- País y Región -->
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-select v-model="user.pais" :items="paises" :label="$t('DatosU.pais')"
                                    item-title="nombre" item-value="id_pais" :rules="[rules.required]" />
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-select v-model="user.region" :items="regiones" :label="$t('DatosU.region')"
                                    item-title="nombre" item-value="id_region" :rules="[rules.required]" />
                            </v-col>

                        </v-row>

                        <!-- Etnia y Género -->
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-select v-model="user.etnia" :items="etnias" :label="$t('DatosU.etnia')"
                                    item-title="nombre" item-value="id_etnia" :rules="[rules.required]" />
                            </v-col>


                            <v-col cols="12" md="6">
                                <v-select v-model="user.genero" :items="generoOptions" :label="$t('DatosU.genero')"
                                    item-value="value" item-title="label" :rules="[rules.required]" />
                            </v-col>

                        </v-row>

                        <!-- Edad y Peso -->
                        <v-row>
                            <v-row>
                                <v-col cols="12" md="4">
                                    <v-select v-model="user.etnia" :items="etnias" :label="$t('DatosU.etnia')"
                                        item-title="nombre" item-value="id_etnia" :rules="[rules.required]" />
                                </v-col>

                                <v-col cols="12" md="4">
                                    <v-select v-model="user.genero" :items="generoOptions" :label="$t('DatosU.genero')"
                                        item-title="label" item-value="value" :rules="[rules.required]" />
                                </v-col>

                                <v-col cols="12" md="4">
                                    <v-select v-model="user.idioma" :items="idiomas" :label="$t('DatosU.idioma')"
                                        item-title="label" item-value="value" :rules="[rules.required]" />
                                </v-col>
                            </v-row>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="user.edad" :label="$t('DatosU.edad')" type="number"
                                    :rules="[rules.required]" />
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-text-field v-model="user.peso" :label="$t('DatosU.peso')" type="number"
                                    :append-inner="selectedPesoUnidad" :rules="[rules.required]" />
                                <v-select v-model="selectedPesoUnidad" :items="pesoUnidades" label="Unidad"
                                    hide-details />
                            </v-col>
                        </v-row>

                        <!-- Estatura -->
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="user.estatura" :label="$t('DatosU.estatura')" type="number"
                                    :append-inner="selectedEstaturaUnidad" :rules="[rules.required]" />
                                <v-select v-model="selectedEstaturaUnidad" :items="estaturaUnidades"
                                    :label="$t('DatosU.unidadestatura')" hide-details />
                            </v-col>
                        </v-row>

                    </v-form>
                </v-card-text>

                <v-card-actions class="d-flex justify-end">
                    <v-btn color="primary" @click="updateUser" elevation="4">{{ $t('app.save') }}</v-btn>
                    <v-btn color="#42A5F5" :href="'/Dashboard'" elevation="4">{{ $t('app.regresar') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>

        <!-- Diálogo de éxito -->
        <v-dialog v-model="dialog" max-width="400" persistent>
            <v-card>
                <v-card-title class="headline">¡Usuario actualizado!</v-card-title>
                <v-card-text>Los cambios se guardaron correctamente.</v-card-text>
                <v-card-actions>
                    <v-btn color="primary" :href="'/Dashboard'">Regresar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Diálogo de error -->
        <v-dialog v-model="errorDialog" max-width="400" persistent>
            <v-card>
                <v-card-title class="headline">Error</v-card-title>
                <v-card-text>{{ errorMessage }}</v-card-text>
                <v-card-actions>
                    <v-btn color="red" @click="errorDialog = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import axios from "axios";
const apiUrl = process.env.VUE_APP_API_URL;

export default {
    data() {
        return {
            idiomas: [
                { label: "Español", value: "es" },
                { label: "English", value: "en" },
            ],

            valid: false,
            dialog: false,
            errorDialog: false,
            errorMessage: "",
            showPassword: false,

            user: {
                nombres: "",
                apellidos: "",
                correo: "",
                pais: null,
                region: null,
                etnia: null,
                genero: "",
                edad: null,
                peso: null,
                estatura: null,
                rol: 1,
                idioma: null,
            },

            pesoUnidades: ["kg", "lb"],
            estaturaUnidades: ["cm", "m", "in"],
            selectedPesoUnidad: "kg",
            selectedEstaturaUnidad: "cm",

            paises: [],
            regiones: [],
            etnias: [],
            generoOptions: [
                { label: "Masculino", value: "M" },
                { label: "Femenino", value: "F" },
                { label: "Otro", value: "M" },
            ],

            rules: {
                required: v => !!v || "Campo obligatorio",
                email: v => /.+@.+\..+/.test(v) || "Email inválido",
            },
        };
    },

    mounted() {
        this.fetchPaises();
        this.fetchEtnias();
        this.loadUserData();
    },

    methods: {
        async loadUserData() {
            try {
                const id = this.$route.params.id;
                const response = await axios.get(`${apiUrl}/api/users/${id}`);
                const data = response.data;

                // Convertimos a tus campos locales
                this.user = {
                    ...data,
                    peso: data.pesoKg,
                    estatura: data.estaturacm,
                };

                this.selectedPesoUnidad = "kg";
                this.selectedEstaturaUnidad = "cm";

                if (this.user.pais) this.fetchRegiones();
            } catch (e) {
                this.errorMessage = "Error cargando el usuario.";
                this.errorDialog = true;
            }
        },

        async fetchPaises() {
            const res = await axios.get(`${apiUrl}/api/paises`);
            this.paises = res.data;
        },

        async fetchRegiones() {
            if (!this.user.pais) return;
            const res = await axios.get(`${apiUrl}/api/regiones/pais/${this.user.pais}`);
            this.regiones = res.data;
        },

        async fetchEtnias() {
            const res = await axios.get(`${apiUrl}/api/etnias`);
            this.etnias = res.data;
        },

        convertPesoToKg(value, unit) {
            if (unit === "lb") return value * 0.453592;
            return value;
        },

        convertEstaturaToCm(value, unit) {
            if (unit === "m") return value * 100;
            if (unit === "in") return value * 2.54;
            return value;
        },

        async updateUser() {
            if (!this.$refs.form.validate()) {
                this.errorMessage = "Por favor, completa todos los campos requeridos.";
                this.errorDialog = true;
                return;
            }

            try {
                const id = this.$route.params.id;

                const payload = {
                    ...this.user,
                    pesoKg: this.convertPesoToKg(this.user.peso, this.selectedPesoUnidad),
                    estaturacm: this.convertEstaturaToCm(this.user.estatura, this.selectedEstaturaUnidad),
                };

                await axios.put(`${apiUrl}/api/users/update/${id}`, payload);

                this.dialog = true;
            } catch (e) {
                this.errorMessage = e.response?.data?.message || "Error al actualizar usuario.";
                this.errorDialog = true;
            }
        },

        goBack() {
            this.$router.push("/");
        },
    },

    watch: {
        "user.pais"(n) {
            this.regiones = [];
            if (n) this.fetchRegiones();
        },
    },
};
</script>

<style scoped>
html,
body {
    height: 100%;
    margin: 0;
    overflow: hidden;
}

.background-image {
    background-image: url("../../images/fondo3.jpg");
    background-size: cover;
    background-position: center;
}

.v-card {
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>
